<h3 class="modal-title">Create a Ticket</h3>
<form
  [formGroup]="ticketForm"
  #ticketFormRef="ngForm"
  (ngSubmit)="onSubmit()"
  type="submit"
>
  <app-form-field
    [label]="'Title'"
    [formControl]="$any(ticketForm.get('title'))"
    [errorType]="'outline'"
    [id]="'title'"
    [placeholder]="'Enter Title...'"
    [error]="!!(ticketForm.get('title')?.invalid && ticketFormRef['submitted'])"
    [maxlength]="titleMaxLength"
  />
  <app-select
    [title]="'Category'"
    [selected]="selectedCategory"
    [options]="categoryOptions"
    [variant]="'form'"
    [error]="
      !!(ticketForm.get('category')?.invalid && ticketFormRef['submitted'])
    "
  />
  <app-form-field
    [label]="'Additional Info'"
    [formControl]="$any(ticketForm.get('additionalInfo'))"
    [errorType]="'outline'"
    [id]="'additionalInfo'"
    [placeholder]="'Enter Additional Info...'"
  />
  <app-textarea
    [label]="'Description'"
    [formControl]="$any(ticketForm.get('description'))"
    [errorType]="'outline'"
    [id]="'description'"
    [placeholder]="'Enter Description...'"
    [error]="
      !!(ticketForm.get('description')?.invalid && ticketFormRef['submitted'])
    "
  />
  <button
    type="submit"
    class="button button--style-yellow padding-x-12 rounded-4 h-32"
  >
    Submit
  </button>
</form>
